import Axios from 'axios';

export const initMiniCartDiscount = (wrapperClass) => {

  const discountWrapper = document.querySelector(`.${wrapperClass}`);
  if (!discountWrapper) {
    return;
  }
  const applyBtn = discountWrapper.querySelector('button');
  const discountCodeInput  = discountWrapper.querySelector('input');
  const discountCodeStatus  = discountWrapper.querySelector('span');
  const minicartCTA = document.querySelector('.minicart-cta')

  function resetButtonState() {
    applyBtn.style.pointerEvents = 'auto';
    applyBtn.innerHTML = 'APPLY';
    if (minicartCTA) {
      minicartCTA.setAttribute('disabled', false)
    }
  }

  function getMarketOrigin() {
    return window.location.origin + window.Shopify?.routes?.root || '/'
  }

  function applyMinicartDiscount(code, errorCounter = 0) {
    applyBtn.innerHTML += '<div class=\'loader\'></div>';
    applyBtn.style.pointerEvents = 'none';
    const discountApplyUrl = getMarketOrigin() + 'checkout?discount='+code+'&no_cookies_from_redirect=1&skip_shop_pay=true&t='+Date.now();

    Axios.get(discountApplyUrl)
      .then((response) => {
        const data = response.data;
        const discountError = data.match('id="error-for-reduction_code"');
        const checkoutDom = new DOMParser().parseFromString(data, 'text/html');
        const checkoutDiscountAmount = checkoutDom.querySelector('#discount_amount').innerHTML;
        
        // if(discountError || (checkoutDiscountAmount === '0')){
        if(discountError){
          // console.log('Invalid discount code');
          const discountErrorMsg = 'Invalid discount code'
          discountCodeStatus.innerHTML = '<small class=\'discount-error-msg\'>' + discountErrorMsg + '</small>';
          discountCodeStatus.style.display = 'flex';
          discountCodeInput.classList.remove('discount-success');
          discountCodeInput.classList.add('discount-error');
          discountCodeInput.style.border = '1px solid #b05353';
        } else {
          // console.log('Valid code. Discount code applied')
          const discountData = checkoutDom.querySelector('#discount_data').textContent.replace(/["']/g, '').trim();
          discountCodeInput.classList.remove('discount-error');
          discountCodeInput.classList.add('discount-success');
          discountCodeInput.style.border = '';
          localStorage.setItem('discountCode', code);
          localStorage.setItem('discountAmount', checkoutDiscountAmount);
          if (discountData !== '') {
            discountCodeStatus.innerHTML = '<p>' + discountData + '</p>';
          }
          discountCodeStatus.style.display = 'flex';
          if (minicartCTA) {
            minicartCTA.setAttribute('disabled', true)
          }
          //redirect to cart with discount applied - NEEDED TO ADD FREE GIFT
          window.location.href = getMarketOrigin() + 'discount/' + code + `?redirect=${encodeURIComponent('/cart')}`;
        }       
        resetButtonState()
      })
      .catch((e) => {
        if (e.response) {
          console.error(e.response)
          errorCounter++;
        } else if (!e.response && e.code && e.code === 'ERR_NETWORK') {
          console.error(e.code, e.message)
          errorCounter++;
        }

        if (errorCounter <= 3) {
          // reset state - retry up to 3 times
          resetButtonState()
          applyMinicartDiscount(code, errorCounter)
        } else {
          const discountErrorMsg = 'Discount code, could not be applied - please try again when on the checkout page'
          discountCodeStatus.innerHTML = '<small class=\'discount-error-msg\'>' + discountErrorMsg + '</small>';
          discountCodeStatus.style.display = 'flex';
          discountCodeInput.classList.remove('discount-success');
          discountCodeInput.classList.add('discount-error');
          discountCodeInput.style.border = '1px solid #b05353';
          resetButtonState()
        }
      });
  }

  if (applyBtn) {
    applyBtn.addEventListener('click', function(e){ 
      e.preventDefault()
      applyMinicartDiscount(discountCodeInput.value, 0);
    });
  }
  const forceInputUppercase = function(e) {
    const el = e.target;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    el.value = el.value.toUpperCase();
    el.setSelectionRange(start, end);
  };

  document.querySelectorAll('.uc-text').forEach(current => {
    current.addEventListener('keyup', forceInputUppercase);
  });
}